import React from "react";
import ReusableDropdown, { unifiedControlStyle } from "../../../components/ReusableDropdown";
import { text } from "../constants/text";

export default function FiltersPanel({
  theme,
  language,
  styles,
  searchTerm,
  setSearchTerm,
  filterDepartment,
  setFilterDepartment,
  filterStatus,
  setFilterStatus,
  filterCompany,
  setFilterCompany,
  departmentsList = [],
  companiesList = [],
  screenSize,
}) {
  const filterBarStyle = {
    display: "flex",
    flexWrap: "wrap",
    gap: screenSize === "xs" ? "10px" : "18px",
    padding: screenSize === "xs" ? "12px" : "18px",
    alignItems: "flex-end",
    justifyContent: "flex-start",
    background: styles?.filterBar?.background || "transparent",
    width: "100%",
    boxSizing: "border-box",
  };

  const filterGroupStyle = {
    display: "flex",
    flexDirection: "column",
    minWidth: screenSize === "xs" ? "100%" : 200,
    flex: "1 1 220px",
    gap: "6px",
    maxWidth: 320,
  };

  return (
    <div style={filterBarStyle}>
      <div style={filterGroupStyle}>
        <label style={styles.filterLabel}>{text[language]?.searchEmployee || "Search"}</label>
        <input
          type="text"
          placeholder={text[language]?.searchNameIdEmail || "Name, ID, Email..."}
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          style={unifiedControlStyle(theme, language === "ar")}
        />
      </div>
      <div style={filterGroupStyle}>
        <label style={styles.filterLabel}>{text[language]?.department || "Department"}</label>
        <ReusableDropdown
          items={[
            { key: "", label: text[language]?.allDepartments || "All" },
            ...departmentsList.map(dep => ({ key: dep, label: dep }))
          ]}
          value={filterDepartment}
          onChange={() => {}}
          onSelect={(item) => setFilterDepartment(item.key)}
          placeholder={text[language]?.searchDepartment || "Search department..."}
          getItemKey={(it) => it.key}
          getItemLabel={(it) => it.label}
          theme={theme}
          language={language}
          maxItems={8}
        />
      </div>
      <div style={filterGroupStyle}>
        <label style={styles.filterLabel}>{text[language]?.Status || "Status"}</label>
        <ReusableDropdown
          items={[
            { key: "", label: text[language]?.allStatuses || "All" },
            { key: "Active", label: text[language]?.statusActive || "Active" },
            { key: "OnLeave", label: text[language]?.statusOnLeave || "On Leave" },
            { key: "Inactive", label: text[language]?.statusInactive || "Inactive" },
          ]}
          value={filterStatus}
          onChange={() => {}}
          onSelect={(item) => setFilterStatus(item.key)}
          placeholder={text[language]?.selectStatus || "Select"}
          getItemKey={(it) => it.key}
          getItemLabel={(it) => it.label}
          theme={theme}
          language={language}
          maxItems={6}
        />
      </div>
      {screenSize !== "xs" && (
        <div style={filterGroupStyle}>
          <label style={styles.filterLabel}>{text[language]?.company || "Company"}</label>
          <ReusableDropdown
            items={[
              { key: "", label: text[language]?.allCompanies || "All" },
              ...companiesList.map((c) => ({ key: c, label: c })),
            ]}
            value={filterCompany}
            onChange={() => {}}
            onSelect={(item) => setFilterCompany(item.key)}
            placeholder={text[language]?.allCompanies || "All"}
            getItemKey={(it) => it.key}
            getItemLabel={(it) => it.label}
            theme={theme}
            language={language}
            maxItems={8}
          />
        </div>
      )}
    </div>
  );
}
